import type { Pass } from './types'
import { ALL_PASSES } from './passes'

// Seeded historical performance per template (for demo mode)
const DEMO_PASS_HISTORY: Record<string, { correct: number; tested: number }> = {
  EVIDENCE_GROUNDED: { correct: 87, tested: 120 },
  SEGMENT_RESPONSE: { correct: 81, tested: 115 },
  SKEPTICAL_RESEARCHER: { correct: 73, tested: 110 },
  BEHAVIORAL_DRIVER: { correct: 79, tested: 108 },
  COUNTERFACTUAL_RISK: { correct: 76, tested: 112 },
  QUANTITATIVE_DIST: { correct: 83, tested: 118 },
  VALIDATION_PLANNER: { correct: 69, tested: 95 },
}

export function selectPassesForSegment(segmentName: string, topK = 5): Pass[] {
  // Layer 1: segment baseline from history
  // Layer 2: question-proxy adjustment (simplified — use keyword overlap stub)
  const scored = ALL_PASSES.map(pass => {
    const hist = DEMO_PASS_HISTORY[pass.template] ?? { correct: 5, tested: 10 }
    // Bayesian blend: (proxy_correct + baseline_correct) / (proxy_tested + baseline_tested)
    const proxyBoost = segmentName.toLowerCase().includes('claim') && pass.template === 'SKEPTICAL_RESEARCHER' ? 5 : 0
    const score = (hist.correct + proxyBoost) / (hist.tested)
    return { pass, score }
  })

  scored.sort((a, b) => b.score - a.score)
  return scored.slice(0, topK).map(s => s.pass)
}
